// extracted by mini-css-extract-plugin
module.exports = {"mapSwitchIcon":"AccountOnboardingLocation_mapSwitchIcon__3s4GT","map":"AccountOnboardingLocation_map__1C7Lj","actionButton":"AccountOnboardingLocation_actionButton__QdKmS"};